import React, { useState, useEffect, useRef } from 'react';
import Breadcrumb from '@/components/common/Breadcrumb';
import Card from '@/components/ui/cards/Card';
import CardHeader from '@/components/ui/cards/CardHeader';
import CardBody from '@/components/ui/cards/CardBody';
import { getByIdDiningTableService } from '@/services/DiningTableServices';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import validationErrors from '@/lib/validationErrors';
import { getFileUrl } from '@/services/CommonService';
import QRCode from 'react-qr-code';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const DiningTableViewPage = ({ pageTitle }) => {
    const printRef = useRef(null);
    const { posOrder, generalSetting } = useSelector((state) => state?.GeneralSetting);
    const { id } = useParams();
    const dispatch = useDispatch();
    const [dataSource, setDataSource] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (id && id != '') {
            getDataById(id);
        }
    }, [id]);

    const getDataById = (id) => {
        setIsLoading(true);
        dispatch(getByIdDiningTableService(id))
            .then((res) => {
                var formData = res?.data?.data;
                setDataSource(formData);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const handleDownloadPdf = async () => {
        const element = printRef.current;
        if (!element) {
            return;
        }
        const printContent = printRef.current.innerHTML; // Get the content to print
        const originalContent = document.body.innerHTML; // Save the current content of the body

        document.body.innerHTML = printContent; // Replace the body content with print content
        window.print(); // Trigger the print dialog
        document.body.innerHTML = originalContent; // Restore the original body content
        window.location.reload(); // Reload to re-mount the React app

        // const canvas = await html2canvas(element, {
        //     scale: 2,
        // });
        // const data = canvas.toDataURL('image/png');

        // const pdf = new jsPDF({
        //     orientation: 'portrait',
        //     unit: 'px',
        //     format: 'a4',
        // });

        // const imgProperties = pdf.getImageProperties(data);
        // const pdfWidth = pdf.internal.pageSize.getWidth();

        // const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;

        // pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight);
        // pdf.save(dataSource?.slug + '.pdf');
    };

    return (
        <>
            <Breadcrumb pageTitle={pageTitle} />
            <Card>
                <CardHeader isBorder={true}>
                    <h3 className="db-card-title">{pageTitle}</h3>
                    <div className="db-card-filter">
                        <button type="button" v-print="printObj" className="db-btn h-[37px] text-white bg-primary" onClick={handleDownloadPdf}>
                            <i className="lab lab-printer-line lab-font-size-17"></i>
                            print
                        </button>
                    </div>
                </CardHeader>
                <CardBody>
                    <div className="db-card-body" id="print" ref={printRef}>
                        <img
                            className="w-36 mx-auto mb-1"
                            src={generalSetting?.theme_logo && generalSetting?.theme_logo != '' ? getFileUrl(generalSetting?.theme_logo, 'theme') : '/assets/images/theme/theme-logo.png'}
                            alt="logo"
                        />
                        <p className="text-center">
                            <span className="block capitalize mt-4">{generalSetting?.company_name}</span>
                            <span className="block">{generalSetting?.company_phone}</span>
                            <span className="block capitalize mb-6">{generalSetting?.company_address}</span>
                        </p>
                        <div style={{ height: 'auto', margin: '0 auto', maxWidth: 220, width: '100%' }}>
                            <QRCode
                                size={256}
                                style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                                value={window.location.hostname + '/menu/table/' + dataSource?.slug}
                                viewBox={`0 0 256 256`}
                            />
                        </div>
                        <p className="text-center mb-6 mt-5">
                            <span className="block capitalize">{dataSource?.name}</span>
                        </p>

                        <p className="text-center">
                            <span className="block font-medium">Please scan & send quick order</span>
                            <span className="block text-lg font-semibold capitalize">Thank You</span>
                        </p>
                    </div>
                </CardBody>
            </Card>
        </>
    );
};

export default DiningTableViewPage;
